<template>
  <InfoCard title="乘机人信息">
    <div class="pass-list">
      <div class="pass-item" v-for="(item, index) in passengers" :key="index">
        <div class="pass-index">{{ index + 1 }}</div>
        <div class="item-content">
          <div class="info-row">
            <div class="label">{{ passengerTypeMap[item.type] }}</div>
            <div class="value">{{ item.name }}</div>
          </div>
          <div class="info-row">
            <div class="label">{{certTypeMap[item.certType] }}</div>
            <div class="value">{{ item.certNo }}</div>
          </div>
          <div class="info-row">
            <div class="label">手机号</div>
            <div class="value">{{ item.mobile }}</div>
          </div>
          <div class="info-row" v-if="item.ticketNo">
            <div class="label">票号</div>
            <div class="value">{{ item.ticketNo }}</div>
          </div>
        </div>
      </div>
    </div>
  </InfoCard>
</template>

<script>
import InfoCard from "@/views/components/infoCard.vue";
export default {
  name: "PassengerInfoCard",
  components: { InfoCard },
  props: {
    passengers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      passengerTypeMap: {
        ADT: "成人",
        CHD: "儿童",
        INF: "婴儿",
      },
      certTypeMap: {
        PP: "护照",
        IP: "电子护照",
      }
    }
  }
};
</script>

<style lang="less" scoped>
.pass-list {
  width: 100%;
  .pass-item {
    width: 100%;
    overflow: hidden;
    display: flex;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
    .item-content {
      flex: 1;
      flex-shrink: 0;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 0 30px;
    }
    .info-row {
      width: 100%;
      overflow: hidden;
      .label {
        width: 76px;
      }
    }
    .pass-index {
      flex-shrink: 0;
      width: 24px;
      color: #929a9f;
      font-size: 16px;
      font-style: italic;
      // margin-right: 10px;
    }
  }
}
</style>
